import React, { useState,useEffect } from 'react';
import {
  Form,
  Input,
  PageHeader,
  Row,
  Col,
  Typography,
  Spin ,
  Button,
} from 'antd';
import { Link,Redirect ,withRouter } from "react-router-dom";
import { UserOutlined, LockOutlined, LoadingOutlined,MailOutlined} from '@ant-design/icons';
import Icontact from "../../assets/img/contact.png";
import "./contact.scss";
// import firebase from "../../firebase"; 
const { Title, Paragraph, Text } = Typography;
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const Contact = (props) => {
  //AsyncStorage.setItem('test', 'I like to save it.');
  const [showLoading, setShowLoading] = useState(false);
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [cnt, setcnt] = useState(0)
  const [error, seterror] = useState('')

 
  useEffect(() => {
   
  }, [])
  

  const onFinish = values => {
    setShowLoading(true)
    console.log('Success:', values);
    
    // firebase.auth().signInWithEmailAndPassword(values.email, values.password).then(
    //   (data) => {
    //     // redirect()
    //     const user = data.user
    //     localStorage.setItem('currentUserId',JSON.stringify(user.uid))
    //     // usersRef.doc(user.uid).collection('profil').doc('state').set({online : new Date()})
    //     // usersRef.doc(user.uid).get().then(response =>{ 
    //     //   localStorage.setItem('currentUser',JSON.stringify(response.data())) 

    //     //   setShowLoading(false)
    //       console.log("work");
    //     // })
    //   },
    //   (err) => {
    //     console.log('failed');
        
    //     setShowLoading(false)
    //     seterror(err)
    //   }
    // )
  };

  const onFinishFailed = errorInfo => {
    return errorInfo.errorFields.length
  };

  return (
      <div className="container">
        <div className="register">
          <Row>
            <Col sm={24}>
              <PageHeader
                  className="site-page-header"
                  onBack={() => props.history.goBack() }
                  title="Back to home"
                  subTitle="This is a subtitle"
                />
            </Col>
          </Row>
          <Row>
            
            <Col md={10} >
              <div className="register-form">
              <Typography>   
                <h1>Get In Touch</h1>
                <small>Have a project in mind?. Let’s chat about your goals</small>
              </Typography>
                <br />
                <br />
                <Form
                  {...layout}
                  name="basic"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                   name="Name"
                   label="Name"
                   rules={[
                     {
                       required: true,
                       message: 'Please input your name!',
                     },
                   ]}
                  >
                    <Input className="rounded-pill" size="large" type="text" placeholder="Your full name" prefix={<UserOutlined />} />
                  </Form.Item>
                  <Form.Item
                   name="email"
                   label="Email"
                   rules={[
                     {
                       type: 'email',
                       message: 'The input is not valid E-mail!',
                     },
                     {
                       required: true,
                       message: 'Please input your E-mail!',
                     },
                   ]}
                  >
                    <Input className="rounded-pill" size="large" type="email" placeholder="Your email account" prefix={
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512"><title>ionicons-v5-d</title>
                        <path d="M320,254.27c-4.5,51-40.12,80-80.55,80s-67.34-35.82-63.45-80,37.12-80,77.55-80S323.88,210.27,320,254.27Z" 
                        style={{fill:'none',stroke:'#ccc',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:32}}/>
                        <path d="M319.77,415.77c-28.56,12-47.28,14.5-79.28,14.5-97.2,0-169-78.8-160.49-176s94.31-176,191.51-176C381,78.27,441.19,150,432.73,246c-6.31,71.67-52.11,92.32-76.09,88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25" 
                        style={{fill:'none',stroke:'#ccc',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:32}}/></svg>
                    } />
                  </Form.Item>

                  <Form.Item
                    label="message"
                    name="message"
                    rules={[
                      {
                        required: true,
                        message: 'this input is required',
                      },
                    ]}
                  >
                    <Input.TextArea style={{borderRadius:"1re5"}} rows={6} placeholder="Type message" />
                  </Form.Item>

                  
                  <Form.Item >
                    <Button  className="btn-dark" 
                      htmlType="submit" 
                      size='large' 
                      shape='round' 
                      block disabled={onFinishFailed>0} 
                      loading={showLoading}
                      >
                     Send message
                    </Button>
                  </Form.Item>
                 

                </Form>
              </div>
            </Col>
            <Col md={14} >
              <img src={Icontact} alt="logo" className="w-100"/>
            </Col>
          </Row>
        </div>
      
      </div>
  );
};

export default withRouter(Contact)